/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import './ClockInModalStyle.css';
import CustomModal from '../CustomModal/CustomModal';
import ModalHeader from '../CustomModal/ModalHeader';
import ModalFooter from '../CustomModal/ModalFooter';
import { fonts, themes } from '../../themes/themes';
import CustomTextField from '../../components/CustomTextField/CustomTextField';
import CustomAutoComplete from '../../components/CustomAutoComplete/CustomAutoComplete';
import Loader from '../../Lottifiers/Loader/Loader';
import _ from 'lodash';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackHandleClockIn: (data: clockInType) => void;
  isLoading: boolean;
  status?: any;
  EmpLocationList: any;
  trans?: any;
}

interface clockInType {
  location_id: string;
  note: string;
}

const DashboardClockInPresenter = ({
  isModalOpen,
  closeModal,
  callBackHandleClockIn,
  isLoading,
  EmpLocationList,
  trans,
}: ModalProps) => {
  const [clockInNote, setClockInNote] = useState('');
  const [locationID, setLocationID] = useState('');
  const [locationTypeName, setLocationTypeName] = useState('');

  const [time, setTime] = useState('');
  useEffect(() => {
    currentTime();
  }, []);

  const currentTime = () => {
    const currentDate = new Date();
    const currentTime: any = currentDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });

    setTime(currentTime);
  };

  setInterval(currentTime, 30000);

  const handleSetLocationType = (leaveName: any) => {
    const getLocation = _.filter(EmpLocationList, function (leave: any) {
      return leave.location_type_name === leaveName;
    });
    if (getLocation.length) {
      const location_type = getLocation[0];
      setLocationID(location_type.id);
      setLocationTypeName(location_type.location_type_name);
    }
  };

  const handleSubmit = () => {
    callBackHandleClockIn({ location_id: locationID, note: clockInNote });
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="473px"
      modalWidth="636px"
    >
      <Grid container>
        <ModalHeader
          modal={{ modal_title: trans('Clock In') }}
          closeModal={closeModal}
        />

        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '1.75em',
          }}
        >
          <Box>
            <Typography
              sx={{
                color: themes.defaultIcon,
                fontSize: '0.938em',
                opacity: '1',
                fontFamily: fonts.fontFamily,
              }}
            >
              {trans('Current Time')}
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                color: themes.defaultSuccess,
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '1.5em',
                textShadow: '0px 1px 1px #00000029',
                opacity: '1',
                fontFamily: fonts.fontFamily,
              }}
            >
              {time}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <CustomAutoComplete
            label={trans('Location Type')}
            options={_.map(EmpLocationList, (Location: any) => {
              return Location.location_type_name;
            })}
            value={locationTypeName}
            onChange={(event: any, newValue: any) => {
              handleSetLocationType(newValue);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              width: 'auto',
              maxWidth: '100%',
              height: '100px',
              marginTop: '1.75em',
            }}
          >
            <CustomTextField
              label={trans('Note')}
              helperText={''}
              value={clockInNote}
              placeholder={trans('Note')}
              onChange={(e: any) => {
                setClockInNote(e.target.value);
              }}
              type={'string'}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              marginTop: '-10em',
              zIndex: '-1',
            }}
          >
            {isLoading && <Loader height={200} width={300} />}
          </Box>
        </Grid>
        <ModalFooter
          onClickSubmit={() => handleSubmit()}
          onClickCancel={() => {
            closeModal();
          }}
          isSubmitting={isLoading}
        />
      </Grid>
    </CustomModal>
  );
};

export default DashboardClockInPresenter;
